const childrenLoaded = require('@alexspirgel/children-loaded');
const transitionAuto = require('@alexspirgel/transition-auto');
import Splide from '@splidejs/splide';

class ComponentSlideshow extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}

		this.slideContentContainerElement = this.querySelector('.component-slideshow__slide-content-container');
		this.slidePreviousButtonElement = this.querySelector('.component-slideshow__previous-next-button.previous');
		this.slideNextButtonElement = this.querySelector('.component-slideshow__previous-next-button.next');
		this.slideCountCurrentElement = this.querySelector('.component-slideshow__slide-count.current');
		this.slideCountTotalElement = this.querySelector('.component-slideshow__slide-count.total');

		for (let slideElementIndex = 0; slideElementIndex < this.slideElements.length; slideElementIndex++) {
			const slideElement = this.slideElements[slideElementIndex];
			const slideContentElement = slideElement.querySelector('.component-slideshow__slide-content');
			const slideContentElementClone = slideContentElement.cloneNode(true);
			slideContentElement.setAttribute('data-slide-index', slideElementIndex.toString());
			this.slideContentContainerElement.append(slideContentElement);
			this.slideContentContainerElement.append(slideContentElementClone);
		}

		this.splideRootSelector = '.splide';
		this.splideRootElement = this.querySelector(this.splideRootSelector);
		this.splide = new Splide(this.splideRootElement, {
			arrows: false,
			autoWidth: true,
			focus: 'center',
			pagination: false,
			speed: 250,
			trimSpace: false,
		});

		this.splide.on('move', (newIndex, prevIndex, destIndex) => {
			this.setCustomActiveSlideData(newIndex);
		});

		this.splide.on('click', (slide, e) => {
			this.splide.go(slide.index);
		});

		this.splide.mount();

		this.slidePreviousButtonElement.setAttribute('aria-controls', this.splideRootElement.id);
		this.slideNextButtonElement.setAttribute('aria-controls', this.splideRootElement.id);
		this.slidePreviousButtonElement.addEventListener('click', () => {
			this.splide.go('<');
		});
		this.slideNextButtonElement.addEventListener('click', () => {
			this.splide.go('>');
		});

		this.slideCountTotalElement.innerHTML = this.splide.length.toString();
		this.setCustomActiveSlideData(0);


		this.initialized = true;

	}

	get slideElements() {
		return Array.from(this.querySelectorAll('.component-slideshow__slide'));
	}

	get activeSlideContentElement() {
		return this.querySelector('.component-slideshow__slide-content.active');
	}

	get slideContentElements() {
		return Array.from(this.querySelectorAll('.component-slideshow__slide-content'));
	}

	transitionSlideContentHeight(previousSlideContentInnerElement, nextSlideContentElement) {
		nextSlideContentElement.style.height = `${previousSlideContentInnerElement.offsetHeight}px`;
		transitionAuto({
			element: nextSlideContentElement,
			property: 'height',
			value: 'auto'
		});
	}

	setCustomActiveSlideData(activeSlideIndex) {

		const activeSlideElement = this.splide.Components.Slides.getAt(activeSlideIndex).slide;

		activeSlideElement.setAttribute('data-slide-state', 'active');

		const slideType = activeSlideElement.getAttribute('data-slide-type');
		this.setAttribute('data-active-slide-type', slideType);

		let previousActiveSlideContentElement = this.activeSlideContentElement;
		for (const slideContentElement of this.slideContentElements) { 
			if (slideContentElement.getAttribute('data-slide-index') == activeSlideIndex.toString()) {
				if (previousActiveSlideContentElement) {

					const previousActiveSlideHeadingInnerElement = previousActiveSlideContentElement.querySelector('.component-slideshow__slide-heading-inner');
					const nextActiveSlideHeadingElement = slideContentElement.querySelector('.component-slideshow__slide-heading');
					this.transitionSlideContentHeight(previousActiveSlideHeadingInnerElement, nextActiveSlideHeadingElement);

					const previousActiveSlideTextInnerElement = previousActiveSlideContentElement.querySelector('.component-slideshow__slide-text-inner');
					const nextActiveSlideTextElement = slideContentElement.querySelector('.component-slideshow__slide-text');
					this.transitionSlideContentHeight(previousActiveSlideTextInnerElement, nextActiveSlideTextElement);

					const previousActiveSlideLinkInnerElement = previousActiveSlideContentElement.querySelector('.component-slideshow__slide-link-inner');
					const nextActiveSlideLinkElement = slideContentElement.querySelector('.component-slideshow__slide-link');
					this.transitionSlideContentHeight(previousActiveSlideLinkInnerElement, nextActiveSlideLinkElement);

				}
				slideContentElement.classList.add('active');
			}
			else {
				slideContentElement.classList.remove('active');
			}
		}

		const activeSlideNumber = activeSlideIndex + 1;
		this.slideCountCurrentElement.innerHTML = activeSlideNumber.toString();

		if (!this.slidePreviousButtonElement.hasAttribute('disabled') && activeSlideNumber <= 1) {
			this.slidePreviousButtonElement.setAttribute('disabled', '');
		}
		else if (this.slidePreviousButtonElement.hasAttribute('disabled') && activeSlideNumber > 1) {
			this.slidePreviousButtonElement.removeAttribute('disabled');
		}
		if (!this.slideNextButtonElement.hasAttribute('disabled') && activeSlideNumber >= this.splide.length) {
			this.slideNextButtonElement.setAttribute('disabled', '');
		}
		else if (this.slideNextButtonElement.hasAttribute('disabled') && activeSlideNumber < this.splide.length) {
			this.slideNextButtonElement.removeAttribute('disabled');
		}

		const inactiveSlides = this.slideElements.filter((slideElement) => {
			if (slideElement !== activeSlideElement) {
				return true;
			}
			else {
				return false;
			}
		});
		for (const inactiveSlide of inactiveSlides) {
			inactiveSlide.setAttribute('data-slide-state', 'inactive');
		}

	}

}

customElements.define('component-slideshow', ComponentSlideshow, {extends: 'div'});